import "./App.css";
import PageLayout from "./components/Pagelayout/Pagelayout";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Loginpage from "./components/Loginpage/Loginpage";
import EnachLogin from "./components/EnachLoginpage/Loginpage";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import ErrorBoundary from "./components/ErrorBoundary";

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: [
        "system-ui",
        "-apple-system",
        "Segoe UI",
        "Roboto",
        "Helvetica Neue",
        "Arial",
        "Noto Sans",
        "Liberation Sans",
        "sans-serif",
        "Apple Color Emoji",
        "Segoe UI Emoji",
        "Segoe UI Symbol",
        "Noto Color Emoji",
      ].join(","),
    },
  },
});

function App() {
  const [isOnline, setIsOnline] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    function handleOnlineStatus(event) {
      setIsOnline(event.type === "online");
    }
    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);
    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, []);
  useEffect(() => {
    if (!navigator.onLine) {
      setIsOnline(false);
    }
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <div className="App">
          <ErrorBoundary navigate={navigate}>
            <Routes>
              <Route path="/stlap/login" element={<Loginpage />} />
              <Route path="/stlap/enachLogin" element={<EnachLogin />} />
              <Route
                path="/"
                exact
                element={<Navigate to="/stlap/login" replace />}
              />
              <Route path="*" exact element={<Loginpage />} />
            </Routes>
          </ErrorBoundary>
        </div>
      </ThemeProvider>
      <Dialog
        open={!isOnline}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Sorry, Your Network is Down, Please Connect to a Network.
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default App;
